export const homeObj = {
  id: "home",
  lightBg: true,
  imgStart: false,
  lightText: false,
  darkText: true,
  topLine: "Belanja mudah kapan saja",
  headLine: "Gratis Ongkir !!!",
  description:
    "Dengan belanja min 100 rb, kami siap antar kerumah anda tanpa tambahan biaya",
  //   buttonLabel:
  img: require("../../images/hero.svg"),
  alt: "premium bank",
  btnLabel: "Belanja Sekarang",
  primary: true,
  dark: true,
  typeDisplay: false,
};

export const homeObjOne = {
  id: "about",
  lightBg: false,
  imgStart: true,
  lightText: true,
  darkText: false,
  topLine: "TENTANG FRESHMART",
  headLine: "Berbelanja produk berkualitas secara online",
  description:
    "Freshmart adalah platform online untuk memudahkan masyarakat akan kebutuhan berbelanja produk harian yang aman dan berkualitas, langsung dari petani dan distributor, Freshmart menjamin harga terbaik untuk produk yang disediakan.",
  //   buttonLabel:
  img: require("../../images/onlineplatform.svg"),
  alt: "premium bank",
  btnLabel: "Get staerted",
  primary: true,
  dark: true,
  typeDisplay: true,
};

export const homeObjTwo = {
  id: "mitra",
  lightBg: true,
  imgStart: false,
  lightText: false,
  darkText: true,
  topLine: "JADILAH MITRA KAMI",
  headLine: "Menambah penghasilan anda hanya dalam gengaman !",
  description:
    " Dengan menjadi mitra, Anda bisa mengasilkan lebih banyak uang sendiri, berapa banyak uang yang ingin Anda hasilkan setiap bulannya? tentukan sendiri. ",
  //   buttonLabel:
  img: require("../../images/mitra.svg"),
  alt: "premium bank",
  btnLabel: "Daftar disini",
  primary: true,
  dark: true,
};
export const homeObjThree = {
  id: "signup",
  lightBg: true,
  imgStart: true,
  lightText: false,
  darkText: true,
  topLine: "buat akun",
  headLine: "Buat akun mu dengan mudah",
  description:
    "Tidak perlu ribet untuk buat acount , hanya butuh beberapa step siap login ke akun anda  ",
  //   buttonLabel:
  img: require("../../images/signup.svg"),
  alt: "premium bank",
  btnLabel: "Sign Up",
  primary: true,
  dark: true,
};
